export default "__VITE_ASSET__B9unCrbY__"